<template>
  <div class="steps-wrapper" :class="{ 'steps-compact': isSmallScreen }">
    <div class="step" :class="{ active: currentStep >= 1, done: currentStep > 1 }">
      <span class="step-num">
        <span v-if="currentStep > 1" class="check-icon">✓</span>
        <span v-else>1</span>
      </span>
      <span class="step-text">选择平台</span>
    </div>
    <div class="step-line" :class="{ active: currentStep > 1 }">
      <div class="line-progress"></div>
    </div>
    <div class="step" :class="{ active: currentStep >= 2, done: currentStep > 2 }">
      <span class="step-num">
        <span v-if="currentStep > 2" class="check-icon">✓</span>
        <span v-else>2</span>
      </span>
      <span class="step-text">手机验证</span>
    </div>
    <div class="step-line" :class="{ active: currentStep > 2 }">
      <div class="line-progress"></div>
    </div>
    <div class="step" :class="{ active: currentStep >= 3, done: currentStep > 3 }">
      <span class="step-num">
        <span v-if="currentStep > 3" class="check-icon">✓</span>
        <span v-else>3</span>
      </span>
      <span class="step-text">身份认证</span>
    </div>
    <div class="step-line" :class="{ active: currentStep > 3 }">
      <div class="line-progress"></div>
    </div>
    <div class="step" :class="{ active: currentStep >= 4, done: currentStep > 4 }">
      <span class="step-num">
        <span v-if="currentStep > 4" class="check-icon">✓</span>
        <span v-else>4</span>
      </span>
      <span class="step-text">选择区域</span>
    </div>
    <div class="step-line" :class="{ active: currentStep > 4 }">
      <div class="line-progress"></div>
    </div>
    <div class="step" :class="{ active: currentStep >= 5 }">
      <span class="step-num">
        <span v-if="currentStep >= 5" class="check-icon">✓</span>
        <span v-else>5</span>
      </span>
      <span class="step-text">完成</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepIndicator',
  props: {
    currentStep: {
      type: Number,
      required: true,
      default: 1
    },
    isSmallScreen: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.steps-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.steps-wrapper::-webkit-scrollbar {
  display: none;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0.6;
  transition: all 0.3s ease;
}

.step.active {
  opacity: 1;
  transform: scale(1.05);
}

.step-num {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.step.active .step-num {
  background: #fff;
  color: #2B77FF;
  box-shadow: 0 4px 15px rgba(255, 255, 255, 0.4);
  transform: scale(1.1);
}

.step.done .step-num {
  background: linear-gradient(135deg, #7EBF50 0%, #6AAD40 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(126, 191, 80, 0.4);
}

.check-icon {
  font-size: 14px;
  font-weight: bold;
}

.step-text {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  font-weight: 500;
  transition: all 0.3s ease;
}

.step.active .step-text {
  color: #fff;
  text-shadow: 0 1px 4px rgba(0,0,0,0.2);
}

.step-line {
  width: 28px;
  height: 3px;
  background: rgba(255,255,255,0.2);
  margin: 0 6px;
  margin-bottom: 20px;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}

.step-line .line-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0;
  background: linear-gradient(90deg, #fff 0%, rgba(255,255,255,0.8) 100%);
  border-radius: 2px;
  transition: width 0.5s ease;
}

.step-line.active .line-progress {
  width: 100%;
}

/* 紧凑模式 */
.steps-wrapper.steps-compact {
  padding: 10px 12px;
}

.steps-wrapper.steps-compact .step-num {
  width: 24px;
  height: 24px;
  font-size: 11px;
}

.steps-wrapper.steps-compact .step-text {
  font-size: 9px;
}

.steps-wrapper.steps-compact .step-line {
  width: 20px;
  margin: 0 4px;
}

@media screen and (max-width: 480px) {
  .step-num {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .step-text {
    font-size: 10px;
  }

  .step-line {
    width: 20px;
    margin: 0 3px;
  }
}

@media screen and (max-width: 360px) {
  .steps-wrapper {
    padding: 10px 8px;
  }
  
  .step-num {
    width: 24px;
    height: 24px;
    font-size: 11px;
  }

  .step-text {
    font-size: 9px;
  }

  .step-line {
    width: 14px;
    margin: 0 2px;
  }
}
</style>
